import React from "react";

import { readOnlyValue } from "../../../../../attributes/lib/attribute-data";

const ServingInfo = (props) => {
    const servingInfo = props.data.map((serving, index) => {
        const { servingAccuracy, header, servingSize, servingSizeMetric, servingSizeVisual, servingsPerContainer, servingSizeDescription } = serving;

        return (
            <div
                key={`serving_${index}_${props.panel}`}
                className="column"
            >
                {header}
                <br />
                <b>Serving Size</b> {servingAccuracy} {readOnlyValue(servingSize, "Measurement")}{" "}
                {servingSizeMetric && `(${readOnlyValue(servingSizeMetric, "Measurement")})`} <br />
                <b>Serving Size (Visual)</b> {servingSizeVisual} <br />
                <b>Servings Per Container</b> {servingsPerContainer} <br />
                <b>Serving Size Description</b> {servingSizeDescription} <br />
            </div>
        );
    });

    return (
        <div className="serving-info">
            <div className="row">{servingInfo}</div>
        </div>
    );
};

export default ServingInfo;
